<template>
  <badge :type="getBadgeType()">
    {{ $t(`ESTABLISHMENT_INTERNAL_INVOICES.STATUS_${transfer.status}`) }}
  </badge>
</template>

<script>
import {
  ESTABLISHMENT_INTERNAL_INVOICE_STATUS_DRAFT,
  ESTABLISHMENT_INTERNAL_INVOICE_STATUS_SUBMITTED,
  ESTABLISHMENT_INTERNAL_INVOICE_STATUS_ACCEPTED,
  ESTABLISHMENT_INTERNAL_INVOICE_STATUS_REJECTED,
  ESTABLISHMENT_INTERNAL_INVOICE_STATUS_CANCELED,
} from "@/constants/establishmentInternalInvoices";

export default {
  name: "establishment-internal-invoice-status-badge",
  props: {
    transfer: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getBadgeType() {
      switch (this.transfer.status) {
        case ESTABLISHMENT_INTERNAL_INVOICE_STATUS_DRAFT:
          return "primary";
        case ESTABLISHMENT_INTERNAL_INVOICE_STATUS_SUBMITTED:
          return "info";
        case ESTABLISHMENT_INTERNAL_INVOICE_STATUS_ACCEPTED:
          return "success";
        case ESTABLISHMENT_INTERNAL_INVOICE_STATUS_REJECTED:
          return "warning";
        case ESTABLISHMENT_INTERNAL_INVOICE_STATUS_CANCELED:
          return "danger";
        default:
          return "default";
      }
    },
  },
};
</script>
